import { render } from "./GenericHeader.vue?vue&type=template&id=01894e18"
import script from "./GenericHeader.vue?vue&type=script&lang=js"
export * from "./GenericHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__